import { FC, memo } from "react"
import spin from "./index.module.scss"
import hexToRgbA from "utils/hex-to-rgba"


interface IProps {
    size?: number
    color?: string
    className?: string
}


const Spin: FC<IProps> = ({ size = 24, color = "#1d3f72", className }) => {
    return (
        <div
            className={spin.donut + ` ${className ?? ""}`}
            style={{
                width: size,
                height: size,
                border: `0.3rem solid rgba(${hexToRgbA(color)}, .3)`,
                borderTopColor: `rgba(${hexToRgbA(color)}, 1)`,
            }}
        />
    )
}

export default memo(Spin)